enum FacetType {
  Range = 'Range',
  Bool = 'Bool',
  AllOfList = 'AllOfList',
  AnyOfList = 'AnyOfList',
  RangeBucket = 'RangeBucket'
}

export default FacetType;
